/**
 * Wrapper para pdfjs-dist que fuerza la versión correcta y el worker correcto
 * SOLUCIÓN DEFINITIVA: Forzar el workerSrc ANTES de que PDF.js lo use
 */

const WORKER_URL = '/pdf.worker.min.js';
const CORRECT_VERSION = '3.11.174';

// CRÍTICO: Interceptar fetch ANTES de importar pdfjs-dist
// Esto previene que PDF.js cargue el worker incorrecto
if (typeof window !== 'undefined') {
          // Interceptar fetch SOLO para URLs de PDF.js worker incorrectas
          if (window.fetch) {
            const originalFetch = window.fetch.bind(window);
            window.fetch = function(...args) {
              const url = args[0];
              // Solo interceptar URLs de PDF.js worker incorrectas
              if (typeof url === 'string' && 
                  (url.includes('pdf.js/5.4.530') || 
                   (url.includes('pdf.js/5') && !url.includes('3.11.174')) ||
                   (url.includes('cdnjs.cloudflare.com/ajax/libs/pdf.js/5') && !url.includes('3.11.174')))) {
                console.warn('[PDF.js Wrapper] ⚠️ BLOQUEADO fetch a worker incorrecto:', url);
                console.warn('[PDF.js Wrapper] ✅ Redirigiendo a worker local:', WORKER_URL);
                return originalFetch(WORKER_URL, ...args.slice(1));
              }
              // Para otras URLs, dejar pasar sin modificar
              return originalFetch(...args);
            };
          }
  
  // Interceptar XMLHttpRequest también
  if (window.XMLHttpRequest) {
    const OriginalXHR = window.XMLHttpRequest;
    window.XMLHttpRequest = function(...args) {
      const xhr = new OriginalXHR(...args);
      const originalOpen = xhr.open;
      xhr.open = function(method, url, ...rest) {
        if (typeof url === 'string' && 
            (url.includes('pdf.js/5.4.530') || 
             (url.includes('pdf.js/5') && !url.includes('3.11.174')))) {
          console.warn('[PDF.js Wrapper] ⚠️ BLOQUEADO XHR a worker incorrecto:', url);
          return originalOpen.call(this, method, WORKER_URL, ...rest);
        }
        return originalOpen.call(this, method, url, ...rest);
      };
      return xhr;
    };
  }
}

// Importar pdfjs-dist
import * as pdfjsLib from 'pdfjs-dist';

// CRÍTICO: Interceptar la construcción de la URL del worker ANTES de que se use
// PDF.js construye la URL usando pdfjsLib.version, así que debemos sobrescribirla
// INMEDIATAMENTE después de importar
if (typeof window !== 'undefined') {
  // Paso 1: Sobrescribir version INMEDIATAMENTE
  try {
    // Leer la versión original primero para debug
    const originalVersion = pdfjsLib.version;
    console.log('[PDF.js Wrapper] Versión original reportada:', originalVersion);
    console.log('[PDF.js Wrapper] Versión correcta esperada:', CORRECT_VERSION);
    
    // CRÍTICO: Si la versión original es incorrecta, forzar la correcta inmediatamente
    if (originalVersion && originalVersion.includes('5.4.530')) {
      console.error('[PDF.js Wrapper] ⚠️ VERSIÓN INCORRECTA DETECTADA:', originalVersion);
      console.error('[PDF.js Wrapper] Esto indica un problema con el empaquetado de Vite');
    }
    
    // Verificar si la propiedad ya está definida antes de intentar redefinirla
    const descriptor = Object.getOwnPropertyDescriptor(pdfjsLib, 'version');
    if (descriptor && !descriptor.configurable) {
      // Si ya está definida y no es configurable, no intentar redefinirla
      console.log('[PDF.js Wrapper] ⚠️ La propiedad version ya está definida y no es configurable, omitiendo redefinición');
      console.log('[PDF.js Wrapper] Versión actual:', pdfjsLib.version);
    } else {
      // Sobrescribir version con getter/setter
      Object.defineProperty(pdfjsLib, 'version', {
        get: () => {
          console.log('[PDF.js Wrapper] version getter llamado, devolviendo:', CORRECT_VERSION);
          return CORRECT_VERSION;
        },
        set: (value) => {
          console.warn('[PDF.js Wrapper] ⚠️ Intento de cambiar versión a:', value, '- BLOQUEADO');
        },
        configurable: true, // Permitir redefiniciones si es necesario
        enumerable: true
      });
      console.log('[PDF.js Wrapper] ✅ Versión sobrescrita a:', CORRECT_VERSION);
      console.log('[PDF.js Wrapper] Verificación - versión actual:', pdfjsLib.version);
    }
  } catch (e) {
    console.warn('[PDF.js Wrapper] No se pudo sobrescribir version:', e);
  }
  
  // Paso 2: FORZAR el workerSrc inmediatamente y protegerlo
  let workerSrcValue = WORKER_URL;
  
  // Proteger workerSrc con getter/setter ANTES de establecerlo
  try {
    Object.defineProperty(pdfjsLib.GlobalWorkerOptions, 'workerSrc', {
      get: () => {
        // Si el valor contiene versión incorrecta, forzar el correcto
        if (workerSrcValue && (workerSrcValue.includes('5.4.530') || 
            (workerSrcValue.includes('cdnjs') && !workerSrcValue.includes('3.11.174')))) {
          console.warn('[PDF.js Wrapper] ⚠️ WorkerSrc incorrecto detectado en getter:', workerSrcValue);
          workerSrcValue = WORKER_URL;
        }
        return workerSrcValue;
      },
      set: (value) => {
        // Bloquear CUALQUIER intento de usar versión incorrecta
        if (value && (value.includes('5.4.530') || 
            (value.includes('cdnjs') && !value.includes('3.11.174')) ||
            (value.includes('pdf.js/5') && !value.includes('3.11.174')))) {
          console.warn('[PDF.js Wrapper] ⚠️ BLOQUEADO cambio a workerSrc incorrecto:', value);
          workerSrcValue = WORKER_URL;
          return;
        }
        workerSrcValue = value || WORKER_URL;
      },
      configurable: true,
      enumerable: true
    });
    
    // Establecer el valor inicial usando el setter
    pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
    console.log('[PDF.js Wrapper] ✅ WorkerSrc forzado y protegido a:', WORKER_URL);
    console.log('[PDF.js Wrapper] Verificación - workerSrc actual:', pdfjsLib.GlobalWorkerOptions.workerSrc);
  } catch (e) {
    console.warn('[PDF.js Wrapper] No se pudo proteger workerSrc, usando asignación directa:', e);
    pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
  }
  
  // Paso 3: Verificación continua para asegurar que el worker no cambie
  const checkWorker = () => {
    const current = pdfjsLib.GlobalWorkerOptions.workerSrc;
    if (current && (current.includes('5.4.530') || 
        (current.includes('cdnjs') && !current.includes('3.11.174')))) {
      console.warn('[PDF.js Wrapper] ⚠️ Worker cambió a versión incorrecta, corrigiendo...');
      pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
    }
  };
  
  // Verificar inmediatamente y periódicamente
  setTimeout(checkWorker, 0);
  setTimeout(checkWorker, 10);
  setTimeout(checkWorker, 100);
  setTimeout(checkWorker, 500);
}

export default pdfjsLib;
export { WORKER_URL, CORRECT_VERSION };
